export default "__VITE_ASSET__CZ_Cd3CM__"